/** Product-facing notification categories (page filters + mute prefs). */
export const NOTIFICATION_CATEGORIES = [
    { value: 'ticket.assigned', label: 'Atribuições' },
    { value: 'ticket.message', label: 'Mensagens' },
    { value: 'ticket.stage', label: 'Mudanças de etapa' },
    { value: 'ticket.approval', label: 'Aprovações' },
];
/**
 * Display labels for every known category (muteable + management-only).
 * Prefer {@link notificationCategoryLabel} at call sites.
 */
export const NOTIFICATION_CATEGORY_LABELS = {
    ...Object.fromEntries(NOTIFICATION_CATEGORIES.map((c) => [c.value, c.label])),
    'org.announcement': 'Avisos da organização',
    'system.broadcast': 'Avisos do sistema',
    'automation.notify': 'Automações',
    'system.test': 'Teste',
};
/** Human label for a category code; falls back to the raw code. */
export function notificationCategoryLabel(category) {
    return NOTIFICATION_CATEGORY_LABELS[category] ?? category;
}
//# sourceMappingURL=categories.js.map